import { render, staticRenderFns } from "./CustomerLayout.vue?vue&type=template&id=7d3d0c16&scoped=true"
import script from "./CustomerLayout.vue?vue&type=script&lang=js"
export * from "./CustomerLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3d0c16",
  null
  
)

export default component.exports